/**
 * Created by lihanying on 2017/6/29.
 */

export const GETCLUBREVENUE = 'GETCLUBREVENUE'




// WEBPACK FOOTER //
// ./src/containers/ClubRevenue/constants.js